import React, { useCallback } from 'react';

import { useRouter } from 'expo-router';

import { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { selectors, useAppSelector } from 'state/global-state';
import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import {
  BadgeText,
  StyledBellIcon,
  StyledNotificationButton,
  UnreadNotificationBadge,
} from './styled';

const MAX_NOTIFICATIONS_IN_BADGE = 9;

export const NotificationsButton = () => {
  const router = useRouter();

  const unreadContentCards = useAppSelector(selectors.loyalty.selectUnreadContentCards);

  const onOpenPanel = useCallback(() => {
    router.navigate(routes.notificationInbox);
  }, [router]);

  return (
    <>
      <StyledNotificationButton
        variant={ActionButtonVariants.TEXT_ONLY}
        size={ActionButtonSizes.SMALL}
        testID="app-header-notification-cta"
        onPress={onOpenPanel}
        startIcon={<StyledBellIcon />}
        accessibilityLabel={t('news')}
      >
        {unreadContentCards > 0 && (
          <UnreadNotificationBadge>
            <BadgeText>
              {unreadContentCards > MAX_NOTIFICATIONS_IN_BADGE
                ? `${MAX_NOTIFICATIONS_IN_BADGE}+`
                : unreadContentCards}
            </BadgeText>
          </UnreadNotificationBadge>
        )}
      </StyledNotificationButton>
    </>
  );
};
